import React, { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
// import GoodsPage from './pages/GoodsPage';
// import EquipmentsPage from './pages/EquipmentsPage';
// import ProductionRelationsPage from './pages/ProductionRelationsPage';
import MaterialStatisticsPage from './pages/MaterialStatisticsPage';
import BlueprintPage from './pages/BlueprintPage';
import { Box } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
      contrastText: '#fff',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
    },
    error: {
      main: '#d32f2f',
      light: '#ef5350',
      dark: '#c62828',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

function App() {
  // 全局阻止滑动返回手势
  useEffect(() => {
    let touchStartX = 0;
    let touchStartY = 0;
    let isHorizontalSwipe = false;

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isHorizontalSwipe = false;
    };

    const handleTouchMove = (e) => {
      const touchX = e.touches[0].clientX;
      const touchY = e.touches[0].clientY;
      const deltaX = touchX - touchStartX;
      const deltaY = touchY - touchStartY;

      // 判断是否主要是横向滑动（需要移动超过10px才判断）
      if (!isHorizontalSwipe && (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10)) {
        isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
      }
      
      // 如果是从屏幕边缘开始的横向滑动（可能是返回手势）
      if (isHorizontalSwipe) {
        const fromLeftEdge = touchStartX < 50; // 从左边缘50px内开始
        const fromRightEdge = touchStartX > window.innerWidth - 50; // 从右边缘50px内开始
        
        // 左边缘向右滑动或右边缘向左滑动
        if ((fromLeftEdge && deltaX > 10) || (fromRightEdge && deltaX < -10)) {
          // 阻止浏览器的返回/前进手势
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };

    const handleTouchEnd = () => {
      isHorizontalSwipe = false;
    };

    // 监听全局触摸事件
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{
        // 只防止横向的过度滚动触发浏览器导航手势，允许纵向滚动链
        overscrollBehaviorX: 'contain',
        overscrollBehaviorY: 'auto',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Router>
          <Navigation />
          <Box sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* <Route path="/goods" element={<GoodsPage />} />
              <Route path="/equipments" element={<EquipmentsPage />} />
              <Route path="/production-relations" element={<ProductionRelationsPage />} /> */}
              <Route path="/material-statistics" element={<MaterialStatisticsPage />} />
              <Route path="/blueprint" element={<BlueprintPage />} />
            </Routes>
          </Box>
          <Footer />
        </Router>
      </Box>
    </ThemeProvider>
  );
}

export default App;